import { create } from 'zustand';

interface NewMessageEvent {
  conversationId: string;
  type: string;
  title: string;
  senderName: string;
  priority: string;
}

interface MessageState {
  unreadCount: number;
  popupQueue: NewMessageEvent[];
  currentPopup: NewMessageEvent | null;
  isPopupOpen: boolean;

  setUnreadCount: (count: number) => void;
  enqueuePopup: (event: NewMessageEvent) => void;
  dismissPopup: () => void;
  clearAll: () => void;
}

export const useMessageStore = create<MessageState>()((set, get) => ({
  unreadCount: 0,
  popupQueue: [],
  currentPopup: null,
  isPopupOpen: false,

  setUnreadCount: (count) => set({ unreadCount: count }),

  enqueuePopup: (event) => {
    const { currentPopup, popupQueue, isPopupOpen } = get();
    if (!isPopupOpen && !currentPopup) {
      set({ currentPopup: event, isPopupOpen: true });
    } else {
      set({ popupQueue: [...popupQueue, event] });
    }
    set({ unreadCount: get().unreadCount + 1 });
  },

  dismissPopup: () => {
    const { popupQueue } = get();
    if (popupQueue.length > 0) {
      const [next, ...rest] = popupQueue;
      set({
        currentPopup: next,
        popupQueue: rest,
        unreadCount: Math.max(0, get().unreadCount - 1),
      });
    } else {
      set({
        currentPopup: null,
        isPopupOpen: false,
        unreadCount: Math.max(0, get().unreadCount - 1),
      });
    }
  },

  clearAll: () =>
    set({
      unreadCount: 0,
      popupQueue: [],
      currentPopup: null,
      isPopupOpen: false,
    }),
}));
